<div
    *ngIf="paletteService.isOpen()"
    class="fixed inset-0 z-[70] flex items-start justify-center bg-[black]/60 px-4 pt-[12vh]"
    role="presentation"
    (click)="onBackdropClick()"
>
    <div
        class="raycast w-full max-w-[640px] overflow-hidden rounded-xl border border-border bg-card shadow-[0_24px_80px_rgba(15,23,42,0.28)]"
        role="dialog"
        aria-modal="true"
        aria-label="Global search"
        (click)="$event.stopPropagation()"
    >
        <cmdk-command
            class="cmdk-command"
            ariaLabel="Search CRM records, pages, and actions"
            [loading]="loading()"
            [filter]="paletteFilter"
        >
            <div class="cmdk-raycast-top-shine"></div>
            <input
                #searchInput
                cmdkInput
                type="search"
                class="cmdk-input w-full !border-none focus:border-none ring-0 bg-transparent text-sm text-black !outline-none placeholder:text-black/40 dark:text-white-dark dark:placeholder:text-white-dark/40 focus:outline-none focus:ring-0 focus:border-transparent"
                placeholder="Search people, companies, leads, deals, pages..."
                aria-label="Search"
                autocomplete="off"
                spellcheck="false"
                [value]="query()"
                (input)="onQueryInput($event)"
            />
            <hr class="cmdk-raycast-loader" />

            <div *cmdkLoader class="cmdk-loader px-4 py-3 text-xs text-black/60 dark:text-white-dark/60">
                Searching CRM records...
            </div>

            <div *cmdkEmpty class="cmdk-empty px-4 py-6 text-center text-sm text-black/60 dark:text-white-dark/60">
                <ng-container *ngIf="showShortQueryHint; else noResults">
                    Type at least 2 characters to search records.
                </ng-container>
                <ng-template #noResults>
                    <ng-container *ngIf="showRecordResults; else browseOnly">
                        No matching records. Try another query or pick a page below.
                    </ng-container>
                    <ng-template #browseOnly>
                        Start typing to search records, or choose navigation and actions below.
                    </ng-template>
                </ng-template>
            </div>

            <cmdk-list class="cmdk-list max-h-[min(60vh,420px)] overflow-y-auto px-2 py-2">
                <ng-container *ngIf="showRecordResults">
                    <cmdk-group
                        *ngFor="let group of recordGroups()"
                        class="cmdk-group"
                        [label]="group.label"
                    >
                        <button
                            *ngFor="let item of group.items"
                            type="button"
                            cmdkItem
                            class="cmdk-item flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm text-black dark:text-white-dark"
                            [value]="item.value"
                            (selected)="onSelect(item)"
                        >
                            <span class="min-w-0 flex-1">
                                <span class="block truncate font-medium">{{ item.title }}</span>
                                <span
                                    *ngIf="item.subtitle"
                                    class="block truncate text-xs text-black/60 dark:text-white-dark/60"
                                >
                                    {{ item.subtitle }}
                                </span>
                            </span>
                            <span class="shrink-0 text-[10px] uppercase tracking-wide text-black/40 dark:text-white-dark/40">
                                {{ group.label }}
                            </span>
                        </button>
                    </cmdk-group>

                    <cmdk-separator
                        *ngIf="recordGroups().length"
                        class="cmdk-separator my-2 border-t border-white-light dark:border-white/10"
                    ></cmdk-separator>
                </ng-container>

                <cmdk-group class="cmdk-group" label="Navigation">
                    <button
                        *ngFor="let item of visibleNavItems"
                        type="button"
                        cmdkItem
                        class="cmdk-item flex w-full items-center rounded-lg px-3 py-2 text-left text-sm text-black dark:text-white-dark"
                        [value]="item.value"
                        (selected)="onSelect(item)"
                    >
                        <ng-icon [name]="item.icon" class="!size-5"></ng-icon>
                        <span class="truncate font-medium">{{ item.title }}</span>
                    </button>
                </cmdk-group>

                <cmdk-separator class="cmdk-separator my-2 border-t border-white-light dark:border-white/10"></cmdk-separator>

                <cmdk-group class="cmdk-group" label="Actions">
                    <button
                        *ngFor="let item of visibleActionItems"
                        type="button"
                        cmdkItem
                        class="cmdk-item flex w-full items-center rounded-lg px-3 py-2 text-left text-sm text-black dark:text-white-dark"
                        [value]="item.value"
                        (selected)="onSelect(item)"
                    >
                        <span class="truncate font-medium">{{ item.title }}</span>
                    </button>
                </cmdk-group>
            </cmdk-list>

            <div class="cmdk-raycast-footer">
                <img src="assets/images/logo.png" alt="ThreadCRM" class="h-5 w-auto" />
        
                <button class="cmdk-raycast-open-trigger">
                  Enter to select
                  <kbd>↵</kbd>
                </button>
        
                <hr />
        
                <!-- <app-sub-command [value]="value"></app-sub-command> -->
            </div>
        </cmdk-command>
    </div>
</div>
